import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MenProduct } from '../data/mensProducts';
import { wishlistService } from '../services/wishlistService';
import { useAuth } from '../contexts/AuthContext';

interface Props { product: MenProduct; }

const MenProductCard: React.FC<Props> = ({ product }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [isHovered, setIsHovered] = useState(false);
  const [inWishlist, setInWishlist] = useState(() => user ? wishlistService.isInWishlist(user.id, product.id) : false);

  const handleWishlist = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!user) { navigate('/login'); return; }
    const { added } = wishlistService.toggle(user.id, {
      id: product.id, productId: product.id, name: product.name,
      price: product.price, imageUrl: product.imageUrl,
      category: product.category, description: product.description,
      detailUrl: `/men/products/${product.id}`,
    });
    setInWishlist(added);
  };

  return (
    <div
      className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300 cursor-pointer"
      onClick={() => navigate(`/men/products/${product.id}`)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={encodeURI(product.imageUrl)} alt={product.name}
          className={`w-full h-full object-cover transition-transform duration-300 ${isHovered ? 'scale-105' : 'scale-100'}`}
        />
        <div className="absolute top-2 left-2">
          <span className="bg-black/70 text-white text-xs px-2 py-1 rounded">
            {product.category.charAt(0).toUpperCase() + product.category.slice(1)}
          </span>
        </div>
        <button
          onClick={handleWishlist}
          className="absolute top-2 right-2 bg-white rounded-full p-1.5 shadow-md hover:scale-110 transition-transform"
          title={inWishlist ? 'Remove from wishlist' : 'Add to wishlist'}
        >
          <svg className={`w-4 h-4 ${inWishlist ? 'text-red-500 fill-red-500' : 'text-gray-400'}`} fill={inWishlist ? 'currentColor' : 'none'} stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
          </svg>
        </button>
      </div>

      <div className="p-4">
        <h3 className="text-sm font-semibold text-gray-800 mb-1 truncate">{product.name}</h3>
        <p className="text-xs text-gray-600 mb-2 line-clamp-2">{product.description}</p>
        <div className="flex justify-between items-center">
          <div>
            <p className="text-lg font-bold text-[#DAA520]">₹{product.price.toFixed(0)}</p>
            <p className="text-xs text-gray-500">Sizes: {product.availableSizes.join(', ')}</p>
          </div>
          <button className="bg-[#E91E63] text-white text-xs px-3 py-1.5 rounded hover:bg-[#D81B60] transition-colors">
            View Details
          </button>
        </div>
      </div>
    </div>
  );
};

export default MenProductCard;
